import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getUnlocks, getCreatorId } from "./api";
import { useAuth } from "./auth";

const UnlocksContext = createContext({
  unlocks: null,
  loading: true,
  refresh: () => {},
  has: () => false,
});

export function UnlocksProvider({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [unlocks, setUnlocks] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await getUnlocks(getCreatorId());
      setUnlocks(data.unlocks || []);
    } catch {
      setUnlocks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch once auth settles; re-fetch when the signed-in user identity changes
  // (guest → user migration exposes newly-owned unlocks).
  useEffect(() => {
    if (authLoading) return;
    refresh();
  }, [authLoading, user?.user_id, refresh]);

  const value = useMemo(
    () => ({
      unlocks,
      loading,
      refresh,
      has: (key) => (unlocks || []).includes(key),
    }),
    [unlocks, loading, refresh]
  );

  return <UnlocksContext.Provider value={value}>{children}</UnlocksContext.Provider>;
}

export const useUnlocks = () => useContext(UnlocksContext);
